
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  SupplierAgency.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierAgency.ts

import {Agency } from "./Agency";
import {Supplier } from "./Supplier";
export class SupplierAgency {

  // int SupplierId
  public SupplierId: number=0;

  // int AgencyId
  public AgencyId: number=0;

  // int IsSupplierAgency
  public IsSupplierAgency: number=0;

  // Agency Agency
  public Agency: Agency=null;

  // Supplier Supplier
  public Supplier: Supplier=null;
}